var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48.0 48.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,900 L0,900 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29133858,0 C8.21366419,0 10.5826772,2.36370859 10.5826772,5.27949091 C10.5826772,8.19527322 8.21366419,10.5589818 5.29133858,10.5589818 C2.36901298,10.5589818 0,8.19527322 0,5.27949091 C0,2.36370859 2.36901298,0 5.29133858,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29133858,0 C8.21366419,0 10.5826772,2.36370859 10.5826772,5.27949091 C10.5826772,8.19527322 8.21366419,10.5589818 5.29133858,10.5589818 C2.36901298,10.5589818 0,8.19527322 0,5.27949091 C0,2.36370859 2.36901298,0 5.29133858,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4330709,0 C24.687874,0 25.7007874,1.0106454 25.7007874,2.26263896 C25.7007874,6.5164002 23.6069291,10.279923 20.4094488,12.6104411 L20.4094488,24.1348156 L5.29133858,24.1348156 L5.29133858,12.6104411 C2.09385827,10.2723809 0,6.50885807 0,2.26263896 C0,1.0106454 1.01291339,0 2.26771654,0 C3.52251969,0 4.53543307,1.0106454 4.53543307,2.26263896 C4.53543307,6.84071179 8.26204724,10.5589818 12.8503937,10.5589818 C17.4387402,10.5589818 21.1653543,6.84071179 21.1653543,2.26263896 C21.1653543,1.0106454 22.1782677,0 23.4330709,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21448819,0 L12.064252,5.75464509 L18.4289764,6.68232706 L13.8179528,11.1623522 L14.9064567,17.482657 L9.21448819,14.4959736 L3.52251969,17.482657 L4.61102362,11.1623522 L0,6.68232706 L6.36472441,5.75464509 L9.21448819,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1653543,2.26263896 C21.1653543,4.95517932 22.0044094,7.45162431 23.4330709,9.51062576 C22.6091339,10.7022823 21.5811024,11.7506383 20.4094488,12.6104411 L20.4094488,24.1348156 L5.29133858,24.1348156 L5.29133858,12.6104411 C2.09385827,10.2723809 0,6.50885807 0,2.26263896 C0,1.0106454 1.01291339,0 2.26771654,0 C3.52251969,0 4.53543307,1.0106454 4.53543307,2.26263896 C4.53543307,6.84071179 8.26204724,10.5589818 12.8503937,10.5589818 C17.4387402,10.5589818 21.1653543,6.84071179 21.1653543,2.26263896 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93385827,0 L8.77606299,5.75464509 L15.1407874,6.67478493 L10.5675591,11.1246416 C10.0459843,11.207605 9.52440945,11.2603999 8.98015748,11.2603999 C5.1703937,11.2603999 1.84440945,9.23156696 0,6.19963075 L3.08409449,5.75464509 L5.93385827,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02362205,0 C5.94897638,0 8.31496063,2.36822878 8.30741964,5.27949091 C8.30741964,5.47558628 8.29984252,5.67168166 8.27716535,5.86023491 C7.43055118,6.44852104 6.40251969,6.78791688 5.29133858,6.78791688 C2.36598425,6.78791688 0,4.42723023 0,1.50842597 C0,1.3123306 0.0151181102,1.11623522 0.0377952756,0.927681974 C0.884409449,0.339395844 1.91244094,0 3.02362205,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02362205,0 C5.94897638,0 8.31496063,2.36822878 8.31496063,5.27949091 C8.31496063,5.47558628 8.30740157,5.67168166 8.28472441,5.86023491 C7.43055118,6.44852104 6.40251969,6.78791688 5.29133858,6.78791688 C2.36598425,6.78791688 0,4.42723023 0,1.50842597 C0,1.3123306 0.0151181102,1.11623522 0.0377952756,0.927681974 C0.884409449,0.339395844 1.91244094,0 3.02362205,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5307087,0 C14.7855118,0 15.7984252,1.0106454 15.7984252,2.26263896 C15.7984252,6.5164002 13.7045669,10.279923 10.5070866,12.602899 L10.5070866,18.7421927 C5.26110236,18.7421927 0.907086614,14.9786699 0,10.0084063 C0.922204724,10.3628864 1.91244094,10.5589818 2.9480315,10.5589818 C7.53637795,10.5589818 11.2629921,6.84071179 11.2629921,2.26263896 C11.2629921,1.0106454 12.2759055,0 13.5307087,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1496063,2.26263896 C11.1496063,4.95517932 11.9886614,7.45162431 13.4173228,9.51062576 C12.5933858,10.7022823 11.5653543,11.7506383 10.3937008,12.6104411 L10.3937008,18.7421927 C5.21574803,18.6893978 0.922204724,14.9711278 0,10.0536591 C0.884409449,10.3779707 1.83685039,10.5589818 2.83464567,10.5589818 C7.42299213,10.5589818 11.1496063,6.84071179 11.1496063,2.26263896 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45696202,0.916368779 C3.62326123,-0.30545626 5.51302501,-0.30545626 5.67932423,0.916368779 C5.69444234,1.01441647 5.70200139,1.11246416 5.70200139,1.21805397 C5.70200139,4.72514436 4.28089903,7.90038103 1.98294627,10.2082728 C1.1363321,11.0605334 -0.375478924,10.1403936 0.0856234381,9.03170051 C0.146095879,8.89594218 0.22168643,8.76772597 0.335072257,8.65459402 C2.33066281,6.66347174 3.43428486,4.02372628 3.43428486,1.21805397 C3.43428486,1.11246416 3.44184391,1.01441647 3.45696202,0.916368779 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85826772,0 C9.08598425,0 11.7165354,2.62466119 11.7165354,5.84515065 C11.7165354,9.0656401 9.08598425,11.6903013 5.85826772,11.6903013 C2.63055118,11.6903013 0,9.0656401 0,5.84515065 C0,2.62466119 2.63055118,0 5.85826772,0 Z M5.85826772,1.13131948 C3.2503937,1.13131948 1.13385827,3.24311584 1.13385827,5.84515065 C1.13385827,8.44718545 3.2503937,10.5589818 5.85826772,10.5589818 C8.46614173,10.5589818 10.5826772,8.44718545 10.5826772,5.84515065 C10.5826772,3.24311584 8.46614173,1.13131948 5.85826772,1.13131948 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85826772,0 C9.08598425,0 11.7165354,2.62466119 11.7165354,5.84515065 C11.7165354,9.0656401 9.08598425,11.6903013 5.85826772,11.6903013 C2.63055118,11.6903013 0,9.0656401 0,5.84515065 C0,2.62466119 2.63055118,0 5.85826772,0 Z M5.85826772,1.13131948 C3.2503937,1.13131948 1.13385827,3.24311584 1.13385827,5.84515065 C1.13385827,8.44718545 3.2503937,10.5589818 5.85826772,10.5589818 C8.46614173,10.5589818 10.5826772,8.44718545 10.5826772,5.84515065 C10.5826772,3.24311584 8.46614173,1.13131948 5.85826772,1.13131948 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0 C25.5647244,0 26.8346457,1.26707782 26.8346457,2.8282987 C26.8346457,5.54346545 26.0182677,8.16058452 24.4686614,10.393055 C24.2872441,10.6494874 23.9395276,10.7173665 23.6825197,10.5363554 C23.4255118,10.3553443 23.3574803,10.0084063 23.5388976,9.75197392 C24.9524409,7.70805672 25.7007874,5.30965943 25.7007874,2.8282987 C25.7007874,1.8930746 24.9373228,1.13131948 24,1.13131948 C23.0626772,1.13131948 22.2992126,1.8930746 22.2992126,2.8282987 C22.2992126,7.71559885 18.3155906,11.6903013 13.4173228,11.6903013 C8.51905512,11.6903013 4.53543307,7.71559885 4.53543307,2.8282987 C4.53543307,1.8930746 3.7719685,1.13131948 2.83464567,1.13131948 C1.89732283,1.13131948 1.13385827,1.8930746 1.13385827,2.8282987 C1.13385827,6.71249558 3.02362205,10.4081392 6.19086614,12.716031 C6.33448819,12.8216208 6.42519685,12.9950898 6.42519685,13.1761009 L6.42519685,24.7004753 C6.42519685,25.0097026 6.16818898,25.2585929 5.85826772,25.2585929 C5.54834646,25.2585929 5.29133858,25.0021605 5.29133858,24.6929332 L5.29133858,13.4551597 C1.97291339,10.921004 0,6.968928 0,2.8282987 C0,1.26707782 1.26992126,0 2.83464567,0 C4.39937008,0 5.66929134,1.26707782 5.66929134,2.8282987 C5.66929134,7.08960207 9.14645669,10.5589818 13.4173228,10.5589818 C17.688189,10.5589818 21.1653543,7.08960207 21.1653543,2.8282987 C21.1653543,1.26707782 22.4352756,0 24,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75149606,0.155855822 C2.97826772,0.367035458 2.99338583,0.729057691 2.77417323,0.955321587 C2.26771654,1.49081281 1.71590551,1.98105125 1.13385827,2.43357904 L1.13385827,13.6788947 C1.13385827,13.988122 0.876850394,14.2370123 0.566929134,14.2370123 C0.257007874,14.2370123 0,13.9805799 0,13.6713525 L0,2.14697811 C0,1.96596699 0.0831496063,1.80004013 0.234330709,1.68690818 C0.846614173,1.23438039 1.42866142,0.729057691 1.95023622,0.178482211 C2.16188976,-0.0477816848 2.52472441,-0.0628659445 2.75149606,0.155855822 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2929548,0.288486467 L13.0066556,5.77915701 L19.0690178,6.65404407 C19.2806714,6.68421259 19.4620887,6.83505519 19.5301202,7.0386927 C19.5981517,7.2423302 19.5376792,7.4685941 19.3864981,7.6194367 L14.9946871,11.8882822 L16.0302776,17.9219861 C16.0680729,18.1331657 15.9773643,18.3518875 15.803506,18.4725616 C15.6296477,18.6007778 15.395317,18.615862 15.2063406,18.5178144 L9.77893907,15.6744314 L4.35153749,18.5253565 C4.26838789,18.5630671 4.17767922,18.5856935 4.08697056,18.5856935 C3.96602568,18.5856935 3.85263985,18.5479829 3.75437214,18.4801037 C3.58051387,18.3518875 3.48980521,18.1407079 3.52760048,17.9295282 L4.56319104,11.8958243 L0.171380011,7.62697883 C0.0201989091,7.47613623 -0.0402735319,7.24987233 0.0277579642,7.04623483 C0.0957894603,6.84259732 0.269647728,6.69175472 0.488860326,6.6615862 L6.55878159,5.77915701 L9.27248237,0.288486467 C9.46145875,-0.0961621558 10.0964194,-0.0961621558 10.2929548,0.288486467 Z M9.77893907,1.81953883 L7.44319104,6.54845426 C7.36004143,6.71438111 7.20130127,6.82751306 7.01232489,6.85768158 L1.78145875,7.61189457 L5.56854537,11.2924539 C5.70460836,11.4206701 5.7650808,11.6092234 5.73484458,11.7902345 L4.84287607,16.986762 L9.52193119,14.5355698 C9.59752174,14.490317 9.68823041,14.4676906 9.77893907,14.4676906 C9.86964773,14.4676906 9.96035639,14.490317 10.043506,14.5355698 L14.7225611,16.986762 L13.8305926,11.7902345 C13.8003564,11.6092234 13.8608288,11.4206701 13.9968918,11.2924539 L17.7764194,7.61189457 L12.5455532,6.85013945 C12.3565769,6.81997093 12.1978367,6.70683898 12.1146871,6.54091213 L9.77893907,1.81953883 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91559055,0.101845283 C4.17259843,0.2828564 4.24062992,0.629794374 4.0592126,0.886226789 C3.2503937,2.05525692 2.26771654,3.08852871 1.13385827,3.94833151 L1.13385827,15.1936471 C1.13385827,15.5104166 0.876850394,15.7593069 0.566929134,15.7593069 C0.257007874,15.7593069 0,15.5028745 0,15.1936471 L0,3.66927271 C0,3.48826159 0.0831496063,3.32233474 0.234330709,3.20920279 C1.36062992,2.38711063 2.32818898,1.39154949 3.12944882,0.245145751 C3.30330709,-0.0112866647 3.65858268,-0.0791658335 3.91559055,0.101845283 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.566929134,0 C0.876850394,0 1.13385827,0.256432415 1.13385827,0.56565974 L1.13385827,7.549672 C1.13385827,7.86644145 0.876850394,8.11533174 0.566929134,8.11533174 C0.257007874,8.11533174 0,7.85889932 0,7.549672 L0,0.56565974 C0,0.256432415 0.257007874,0 0.566929134,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83464567,0 C4.39937008,0 5.66929134,1.26707782 5.66929134,2.8282987 C5.66929134,7.08960207 9.14645669,10.5589818 13.4173228,10.5589818 C17.688189,10.5589818 21.1653543,7.08960207 21.1653543,2.8282987 C21.1653543,2.51907138 21.4223622,2.26263896 21.7322835,2.26263896 C22.0422047,2.26263896 22.2992126,2.51907138 22.2992126,2.8282987 C22.2992126,7.71559885 18.3155906,11.6903013 13.4173228,11.6903013 C8.51905512,11.6903013 4.53543307,7.71559885 4.53543307,2.8282987 C4.53543307,1.8930746 3.7719685,1.13131948 2.83464567,1.13131948 C1.89732283,1.13131948 1.13385827,1.8930746 1.13385827,2.8282987 C1.13385827,6.71249558 3.02362205,10.4081392 6.19086614,12.716031 C6.33448819,12.8216208 6.42519685,12.9950898 6.42519685,13.1761009 L6.42519685,15.6499195 C6.42519685,15.9666889 6.16818898,16.2155792 5.85826772,16.2155792 C5.54834646,16.2155792 5.29133858,15.9591468 5.29133858,15.6499195 L5.29133858,13.4551597 C1.97291339,10.921004 0,6.968928 0,2.8282987 C0,1.26707782 1.26992126,0 2.83464567,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.880128523,0.0937763478 L3.14784506,1.60220232 C3.40485293,1.77567131 3.48044348,2.13015141 3.30658522,2.38658383 C3.20075844,2.56005281 3.01934112,2.64301624 2.8379238,2.64301624 C2.73209703,2.64301624 2.6187112,2.61284772 2.52044348,2.54496855 L0.252726948,1.03654258 C-0.00428092579,0.863073594 -0.079871477,0.50859349 0.0939867907,0.252161075 C0.267845058,-0.0042713405 0.623120649,-0.0796926392 0.880128523,0.0937763478 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30853812,0.254109603 C3.48239638,0.510542018 3.41436489,0.865022122 3.14979796,1.03849111 L0.882081423,2.54691708 C0.791372762,2.60725412 0.677986935,2.63742264 0.572160163,2.63742264 C0.390742841,2.63742264 0.209325518,2.54691708 0.095939691,2.38853235 C-0.0779185767,2.13209994 -0.00988708065,1.77761984 0.254679848,1.60415085 L2.52239638,0.0957248753 C2.77940426,-0.0777441116 3.13467985,-0.00986494279 3.30853812,0.254109603 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.880128523,0.0937763478 L3.14784506,1.60220232 C3.40485293,1.77567131 3.48044348,2.13015141 3.30658522,2.38658383 C3.20075844,2.56005281 3.01934112,2.64301624 2.8379238,2.64301624 C2.73209703,2.64301624 2.6187112,2.61284772 2.52044348,2.54496855 L0.252726948,1.03654258 C-0.00428092579,0.863073594 -0.079871477,0.50859349 0.0939867907,0.252161075 C0.267845058,-0.0042713405 0.623120649,-0.0796926392 0.880128523,0.0937763478 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30853812,0.254109603 C3.48239638,0.518084148 3.41436489,0.865022122 3.14979796,1.03849111 L0.882081423,2.54691708 C0.791372762,2.60725412 0.677986935,2.63742264 0.572160163,2.63742264 C0.390742841,2.63742264 0.209325518,2.54691708 0.095939691,2.38853235 C-0.0779185767,2.13209994 -0.00988708065,1.77761984 0.254679848,1.60415085 L2.52239638,0.0957248753 C2.77940426,-0.0777441116 3.13467985,-0.00986494279 3.30853812,0.254109603 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69858268,0 C3.00850394,0 3.26551181,0.256432415 3.26551181,0.56565974 C3.26551181,0.874887064 3.01606299,1.13131948 2.69858268,1.13131948 L0.566929134,1.13131948 C0.257007874,1.13131948 0,0.874887064 0,0.56565974 C0,0.256432415 0.257007874,0 0.566929134,0 L2.69858268,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.69858268,0 C3.00850394,0 3.26551181,0.256432415 3.26551181,0.56565974 C3.26551181,0.874887064 3.01606299,1.13131948 2.69858268,1.13131948 L0.566929134,1.13131948 C0.257007874,1.13131948 0,0.874887064 0,0.56565974 C0,0.256432415 0.257007874,0 0.566929134,0 L2.69858268,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-696.0 -333.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(696.0 333.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5669291338581388 0.5373767529563338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.559055118110347 19.74529598931496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 10.5826772,0 10.5826772,10.5589818 0,10.5589818 0,0",
    stroke: "none",
    fill: "#E2E2E2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.724409448819692 19.74529598931496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 10.5826772,0 10.5826772,10.5589818 0,10.5589818 0,0",
    stroke: "none",
    fill: "#E2E2E2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.165354330709345 22.762147935734642)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 25.7007874,0 25.7007874,24.1348156 0,24.1348156 0,0",
    stroke: "none",
    fill: "#EF4951"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.218582677165639 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 18.4289764,0 18.4289764,17.482657 0,17.482657 0,0",
    stroke: "none",
    fill: "#FFAB02"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 22.762147935734642)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 23.4330709,0 23.4330709,24.1348156 0,24.1348156 0,0",
    stroke: "none",
    fill: "#7CB5E8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.49921259842452 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.1407874,0 15.1407874,11.2603999 0,11.2603999 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "30%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.826771653542906 19.74529598931496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.30743761,0 8.30743761,6.78791688 0,6.78791688 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "40%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.99212598425225 19.74529598931496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.31496063,0 8.31496063,6.78791688 0,6.78791688 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "40%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.06771653543369 22.762147935734635)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 15.7984252,0 15.7984252,18.7421927 0,18.7421927 0,0",
    stroke: "none",
    fill: "#E2E2E2",
    opacity: "30%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.015748031495619 22.762147935734635)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13.4173228,0 13.4173228,18.7421927 0,18.7421927 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "30%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.16414034144515 23.80673292218272)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.79023463e-15,-1.33226763e-15 5.70200139,-1.33226763e-15 5.70200139,10.5422179 1.79023463e-15,10.5422179 1.79023463e-15,-1.33226763e-15",
    stroke: "none",
    fill: "#E2E2E2",
    opacity: "30%"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.559055118110345 19.71701300231738)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i12)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.7165354,0 11.7165354,11.6903013 0,11.6903013 0,0",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.724409448819678 19.71701300231738)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i13)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 11.7165354,0 11.7165354,11.6903013 0,11.6903013 0,0",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.165354330709327 22.74140707860278)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i14)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 26.8346457,0 26.8346457,25.2585929 0,25.2585929 0,0",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.574803149606 33.76298771851405)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i15)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-8.8817842e-16 2.93037881,-8.8817842e-16 2.93037881,14.2370123 0,14.2370123 0,-8.8817842e-16",
    stroke: "none",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.221060933436108 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i16)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 19.5578781,0 19.5578781,18.5856935 0,18.5856935 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "70.3683036%"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.40944881889848 32.2406931148416)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i17)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,-2.19269047e-15 4.16128643,-2.19269047e-15 4.16128643,15.7593069 0,15.7593069 0,-2.19269047e-15",
    stroke: "none",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.291338582677788 39.88466826413173)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i18)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.13385827,0 1.13385827,8.11533174 0,8.11533174 0,0",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 22.73386494873705)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i19)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 22.2992126,0 22.2992126,16.2155792 0,16.2155792 0,0",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.74475336673822 12.17161234690502)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i20)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2.10942375e-15,-1.05471187e-15 3.40057201,-1.05471187e-15 3.40057201,2.64301624 2.10942375e-15,2.64301624 2.10942375e-15,-1.05471187e-15",
    stroke: "none",
    fill: "rgba(255, 255, 255, 0.7)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.84516267120491 12.17720594919241)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i21)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.85722573e-16,4.85722573e-16 3.40447781,4.85722573e-16 3.40447781,2.63742264 4.85722573e-16,2.63742264 4.85722573e-16,4.85722573e-16",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.8707376187067 0.8584175478317773)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i22)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.05471187e-15,-1.11022302e-16 3.40057201,-1.11022302e-16 3.40057201,2.64301624 -1.05471187e-15,2.64301624 -1.05471187e-15,-1.11022302e-16",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.719178419236407 0.8640111501190402)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i23)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.04083409e-15,0 3.40447781,0 3.40447781,2.63742264 -1.04083409e-15,2.63742264 -1.04083409e-15,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.07086614173204 6.895392230035213)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i24)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.26551181,0 3.26551181,1.13131948 0,1.13131948 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.52755905511731 6.895392230035213)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i25)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3.26551181,0 3.26551181,1.13131948 0,1.13131948 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6570edd9509d7862dfa2cb09f8d3d575.svg";
export { ForwardRef as ReactComponent };